import { render } from "./BlockLink.vue?vue&type=template&id=50370efb"
import script from "./BlockLink.vue?vue&type=script&lang=js"
export * from "./BlockLink.vue?vue&type=script&lang=js"

import "./BlockLink.vue?vue&type=style&index=0&id=50370efb&lang=scss"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__